<template>
  <div class="panel-title">
    <div class="back-title" :class="info.narrow?'narrow':''">
      {{info.enName?info.enName:'INTRODUCTION'}}
    </div>
    <div class="title-name">
      {{ info.name ? info.name : "会议介绍" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTitle",
  props: {
    info:{}
  },
  computed: {},
  methods: {}
};
</script>
